import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './WorkspaceLayout.module.scss';

type Props = {
  recordingPanel: ReactNode;
  documents: ReactNode;
  className?: string;
};

// The start and recording pages' workspace: the template or the note, with
// the recording (and, before it, the template's tools) on the right above
// the place kept for the AI agent. The recording panel stays first in the
// DOM, so it is read and tabbed to first.
export const WorkspaceLayout: FC<Props> = ({
  recordingPanel,
  documents,
  className,
}) => (
  <div className={cn(styles.layout, className)}>
    <aside
      className={styles.recordingPanel}
      data-component="transcriptor-modal-recording"
    >
      {recordingPanel}
      <section className={styles.tools} data-section="transcriptor-tools-slot">
        <h3 className={cn('p4', styles.toolsTitle)}>
          <FormattedMessage
            id="workspace.agent.title"
            defaultMessage="AI agent"
          />
        </h3>
      </section>
    </aside>
    <main
      className={styles.documents}
      data-component="transcriptor-modal-documents"
    >
      {documents}
    </main>
  </div>
);
